'use client';

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useToast } from '@/contexts/ToastContext';
import { useServiceWorkerUpdate } from '@/hooks/useServiceWorkerUpdate';

/**
 * djangoログイン成功後、コールバックエンドポイントで
 * 成功メッセージ & homeへリダイレクトする。
 */
const LoginCallbackIndex: React.FC = () => {
  const navigate = useNavigate();
  const { showSuccessMessage } = useToast();
  const { forceUpdateServiceWorker, hasUpdate } = useServiceWorkerUpdate();

  /**
   * ログインリダイレクト後の処理
   */
  const afterLoginRedirect = async () => {
    // MOTE: 要本番環境確認:デバッグモードの場合２回実行（表示）される。
    // これはReact 18のStrict Modeによるもの。

    try {
      // ログイン時にサービスワーカーを強制的に更新チェック
      console.log('Checking for service worker updates after login...');
      const updated = await forceUpdateServiceWorker();

      if (updated) {
        console.log('Service worker updated during login');
      } else {
        console.log('No service worker update needed during login');

        // 更新が検出されなかった場合、少し待ってから再度チェック
        setTimeout(() => {
          if (hasUpdate) {
            console.log('Update detected after delay, applying update...');
            forceUpdateServiceWorker().catch((error) => {
              console.error('Error updating service worker after delay:', error);
            });
          }
        }, 2000);
      }
    } catch (error) {
      console.error('Error updating service worker during login:', error);
    }

    showSuccessMessage('ログインしました。');
    navigate('/home', { replace: true, state: { skipLoading: true } });
  };

  useEffect(() => {
    afterLoginRedirect();
  }, []);

  return <h3 className="text-gray-500 text-lg font-semibold mb-4">login...</h3>;
};

export default LoginCallbackIndex;
